'use strict';
define(['./newsLettercomponent', './FooterOverlay', './pageSpecificComponent', './LazyloadImage', './cookieService', './recentlyviewedcomponent', './brandNewslettercomponent'
], function (NewsLettercomponent, FooterOverlay, PageSpecificComponent, LazyloadImage, mnsCookieService, RecentlyViewedComponent, BrandNewsletterComponent) {

    function Footer() {
        new NewsLettercomponent();
        new PageSpecificComponent();
        new BrandNewsletterComponent();
        FooterOverlay.initOverlay();
        LazyloadImage.init();
        var sessionStorage = window.sessionStorage;
        var textlinkheadings = document.querySelectorAll('.navfooter-textlinks__heading');
        var panel = document.querySelectorAll('.navfooter-footerlinkslist'), i, j;
        if (window.innerWidth < '768') {
            for (i = 0; i < textlinkheadings.length; i++) {
                textlinkheadings[i].addEventListener('click', togglefunction);
                textlinkheadings[i].addEventListener('keydown', togglefunction);
                panel[i].addEventListener('keydown', togglefunction);
                textlinkheadings[i].setAttribute('role', 'button');
                textlinkheadings[i].removeAttribute('aria-level');
            }
        }
        else{
            for (i = 0; i < textlinkheadings.length; i++) {
                textlinkheadings[i].setAttribute('role', 'heading');
                textlinkheadings[i].setAttribute('aria-level', '2');
            }
        }
        function togglefunction(evt) {
            var keyPressed = evt.key || evt.keyCode || evt.type;
            switch (keyPressed) {
                case 'Enter':
                case 'click':
                    if (evt.target.classList.contains('navfooter-textlinks__heading')) {
                        evt.preventDefault();
                        var setClasses = !evt.target.classList.contains('active');
                        setClass(textlinkheadings, 'active', 'remove');
                        setClass(panel, 'nav-footer-accordian', 'remove');
                        if (setClasses) {
                            evt.target.classList.toggle('active');
                            evt.srcElement.nextElementSibling.classList.toggle('nav-footer-accordian');
                            evt.target.setAttribute('aria-expanded', 'true');
                        }
                    }
                    if (keyPressed === 'click') {
                        setblur(textlinkheadings);
                    }
                    break;

                case 'Home':
                case '36':
                    evt.preventDefault();
                    document.querySelector('.navfooter-textlinks__heading').focus();
                    break;

                case 'End':
                case '35':
                    evt.preventDefault();
                    textlinkheadings[textlinkheadings.length - 1].focus();
                    break;

                case 'Escape':
                case 'Esc':
                case '27':
                    if (!evt.target.classList.contains('navfooter-textlinks__heading')) {
                        evt.srcElement.parentNode.parentNode.previousElementSibling.classList.remove('active');
                        evt.srcElement.parentNode.parentNode.classList.remove('nav-footer-accordian');
                        evt.srcElement.parentNode.parentNode.previousElementSibling.focus();
                        evt.srcElement.parentNode.parentNode.previousElementSibling.setAttribute('aria-expanded', 'false');
                    }
                    break;
            }
        }

        function setClass(els, className, fnName) {
            for (var i = 0; i < els.length; i++) {
                els[i].classList[fnName](className);
                if (els[i].classList.contains('navfooter-textlinks__heading')) {
                    els[i].setAttribute('aria-expanded', 'false');
                }
            }
        }
        function setblur(element) {
            for (var i = 0; i < element.length; i++) {
                element[i].blur();
            }

        }
        window.addEventListener('resize', onResizeEvent);

        function onResizeEvent() {
            if (window.innerWidth < '768') {
                for (i = 0; i < textlinkheadings.length; i++) {
                    textlinkheadings[i].addEventListener('click', togglefunction);
                    textlinkheadings[i].addEventListener('keydown', togglefunction);
                    panel[i].addEventListener('keydown', togglefunction);
                    textlinkheadings[i].setAttribute('role', 'button');
                    textlinkheadings[i].removeAttribute('aria-level');
                }
            }
            else {
                for (i = 0; i < textlinkheadings.length; i++) {
                    textlinkheadings[i].removeEventListener('click', togglefunction);
                    textlinkheadings[i].removeEventListener('keydown', togglefunction);
                    panel[i].removeEventListener('keydown', togglefunction);
                    textlinkheadings[i].setAttribute('role', 'heading');
                    textlinkheadings[i].setAttribute('aria-level', '2');
                }
            }
            var slideproductItem = document.querySelectorAll('.navfooter-desktopcarousel__slide-productitem');
            var slideProductWrapper = document.querySelector('.navfooter-desktopcarousel__slide-product-wrapper');
            if ('1280' <= window.innerWidth && window.innerWidth < '1920' && slideproductItem && slideProductWrapper) {
                for (j = 0; j < slideproductItem.length; j++) {
                    slideproductItem[j].style.width = (slideProductWrapper.offsetWidth - 112) / 6 + 'px';
                }
            }
            else if (('1280' > window.innerWidth || window.innerWidth > '1920') && slideproductItem && slideProductWrapper) {
                for (j = 0; j < slideproductItem.length; j++) {
                    slideproductItem[j].style.width = 'auto';
                }
            }
        }

        window.addEventListener('scroll', listenScrollEvent);

        function listenScrollEvent() {
            var footerPosition = (window.scrollY) + (window.innerHeight);
            var bodyHeight = (document.body.offsetHeight) - 1300;
            if ((footerPosition > window.innerHeight) && (footerPosition > bodyHeight)) {
                sessionStorage.setItem('pageScrolledTillBottom', 'true');
            }
            else {
                var data = sessionStorage.getItem('pageScrolledTillBottom');
                if (data) {
                    sessionStorage.removeItem('pageScrolledTillBottom');
                }
            }

        }

        if (window.sessionStorage && sessionStorage.getItem('pageScrolledTillBottom')) {
            this.imageList = document.querySelectorAll('#navigation-commonfooter img[data-src]');
            this.imageSrcList = document.querySelectorAll('#navigation-commonfooter img[src]');
            this.imagesrclistLength = this.imageSrcList.length;
            if ((this.imageList) && (this.imagesrclistLength === 0)) {
                for (var iImage = 0; iImage < this.imageList.length; iImage++) {
                    this.imageList[iImage].src = this.imageList[iImage].attributes['data-src'].value;
                }
            }
        }
        var newsLetterElement = document.getElementById('newsLetterComponentEnable');
        if (mnsCookieService.isUserLoggedIn() && newsLetterElement) {
            newsLetterElement.style.display = 'none';
        }

        /* Recently viewed Item code*/
        var recentlyviewContainer = document.querySelector('.navfooter-recentlyviewContainer');

        if (recentlyviewContainer) {
            new RecentlyViewedComponent();
        }
        /* providing display none to footer in mobile app web view pages*/
        var platformCookie = document.cookie.match('platform');
        var commonfooterSection = document.getElementById('navigation-commonfooter');
        if ((platformCookie !== null) && (platformCookie.input) && (commonfooterSection)) {
            (platformCookie.input.indexOf('mobileapp') !== -1) ? commonfooterSection.style.display = 'none' : false;
        }

        var dcpplusElement = document.querySelector('.dot-com-plus-menu');
        var copyRigtSection = document.querySelector('.navfooter-legallinkscontainer-legaldiv');
        if (dcpplusElement) {
            copyRigtSection.classList.add('navigation-storespecificclass');
        }

        function newsLetterHandler(path) {
            var brandNewsletterElement = document.getElementById('brandNewsLetterComponentEnable');
            var newsLetterElement = document.getElementById('newsLetterComponentEnable');
            var key = 'jaeger';
            var brand = document.querySelector('.product-info__brand');
            if (newsLetterElement && (path.indexOf(key) !== -1 || brand && brand.textContent.toLowerCase() === key)) {
                brandNewsletterElement.style.display = 'block';
                brandNewsletterElement.classList.add('bg-image__show');
                newsLetterElement.style.display = 'none';
            } else if (brandNewsletterElement) {
                brandNewsletterElement.style.display = 'none';
                brandNewsletterElement.classList.remove('bg_image__show');
                if (mnsCookieService.isUserLoggedIn() && newsLetterElement) {
                    newsLetterElement.style.display = 'none';
                } else {
                    newsLetterElement.style.display = 'block';
                }
            }
        }

        var path = window.location.pathname;
        newsLetterHandler(path);
        document.querySelector('body').addEventListener('click', function (event) {
            if (event.target.tagName.toLowerCase() === 'a' && !event.target.href.includes('javascript:')) {
                path = event.target.href ? event.target.href : false;
                if (path) {
                    newsLetterHandler(path);
                }
            }
        });
        window.addEventListener('popstate', function () {
            newsLetterHandler(window.location.href);
        });
    }
    return Footer;
});


/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/Index.js
 **/